import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import Auth from '~models/auth'
import SamsungSmartThingsAuthRepository from '~repositories/impl/samsung.smart-things/auth-repository'

interface OAuth2SignInWithSamsungAccountParams {
  grant_type: 'authorization_code'
  code: string
  client_id: string
  state: string
  redirect_uri: string
  callback_uri: string
  anonymous_code: string
}

const useSamsungSmartThingsOAuth2Request = (
  options?: UseMutationOptions<Auth.LogIn.Response, Error, OAuth2SignInWithSamsungAccountParams>
) => {
  return useMutation({
    ...options,
    mutationFn: SamsungSmartThingsAuthRepository.signInWithSamsungAccountByOAuth,
  })
}

export default useSamsungSmartThingsOAuth2Request
